import React, { Fragment } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';

import store from '../../App/store';

import { ThemeProps } from '../../../shared/prop-types/ReducerProps';
import Form from './form';

const FormModal = (props) => {
  const {
    id,
    subjectPeriodId,
    onHideForm,
    logContents,
    title,
    onConfirm,
    onCancel = () => {
    },
    color,
  } = props;

  const { theme } = store.getState();

  const modalClass = 'modal-dialog--header';

  const customUI = ({ onClose }) => (
    <Modal
      size="lg"
      isOpen
      modalClassName={`modal ltr-support ${theme.className}`}
      className={`modal-dialog--${color || 'warning'} ${modalClass} modal-registers`}
      style={{ width: '1000px', maxWidth: '1200px' }}
    >
      <div className="modal__header">
        <h4 className="text-modal  modal__title">{title}</h4>
      </div>
      <div className="modal__body" style={{ padding: '10px 0 0 0' }}>
        <Provider store={store}>
          <Fragment>
            <Form
              id={id}
              subjectPeriodId={subjectPeriodId}
              onHideForm={onHideForm}
              logContents={logContents}
              onBack={() => { onCancel(); onClose(); onHideForm(); }}
              handleSubmit={values => onConfirm({ ...values, onClose })}
            />
          </Fragment>
        </Provider>
      </div>
    </Modal>
  );

  customUI.propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  return confirmAlert({
    customUI,
  });
};

FormModal.propTypes = {
  title: PropTypes.string.isRequired,
  theme: ThemeProps.isRequired,
  id: PropTypes.number.isRequired,
  subjectPeriodId: PropTypes.number.isRequired,
  onHideForm: PropTypes.func.isRequired,
  logContents: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.string,
  })).isRequired,
  // onConfirm: PropTypes.func.isRequired,
  // onCancel: PropTypes.func.isRequired,
};

FormModal.defaultProps = {
  yesLabel: 'Guardar',
  noLabel: 'Cancelar',
};

export default FormModal;
